export default __webpack_public_path__ + "static/media/raleway-black.eef1ff81.ttf";